const defaultOption = {
  "row": "[insEqualizeRow]",
  "column": "[insEqualizeColumn]",
  "elemsToEqualize": [
      "[insEqualizeElem]", 
  ]
}

export default class EqualizeByRow {
  /**
   * 
   * @param {any | string} $row 
   * @param {string} columns 
   * @param {string[]} elemsToEqualize 
   * @param {{string, number}[]} responsive
   */

  
  constructor(options) {
    // Extend with default option
    let opt = $.extend(defaultOption, options );
    // Selecteur ou objet jQuery du conteneur
    this.$row = (typeof opt.row == "string") ? $(opt.row) : opt.row;
    // Selecteur d'un bloc
    this.$columns = this.$row.find(opt.column);
    // Sélecteur des éléments à égaliser
    this.elemsToEqualize = opt.elemsToEqualize;
    // Responsive : Si aucun responsive ernseigné => On applique les heigt à toutes les colonnes (cas du slider)
    this.responsive = opt.responsive;
    // Exemple
    // "row": ".row",
    // "column": ".column",
    // "elemsToEqualize": [
    //     ".titre", 
    //     ".head", 
    //     ".desc"
    // ],
    // "responsive": [
    //     {"large": 2},
    //     {"xlarge": 3}
    // ],

    if(this.$row.length){
      this.init();
    }
  }

  init(){
    this.equalize();
    $(window).on("resize", _ => {
      this.throttle(this.equalize.bind(this), 100);
    })
  }

  /**
   * 
   */
  equalize() {
    let columnsByRow = this.groupColumn(this.getColByRow());
    
    if(!columnsByRow.length){
      this.resetAllHeight();
    }
    else{
      this.elemsToEqualize.forEach(elClass => {
        columnsByRow.forEach(element => {
          let groups = [];
          element.each((_i, column) => {
            let $column = $(column);
            groups.push($column.find(elClass));
          });
          this.applyHeight(groups);
        });
      });
    }
  }

  /**
   * Retourne le nombre de colonne par ligne en fonction des média queries
   * @return {number}
   */
  getColByRow(){
    let col = 0;

    if(this.responsive){
      this.responsive.forEach(element => {
        let query = Object.keys(element)[0];
        if (Foundation.MediaQuery.atLeast(query)) {
          col = element[query]
        }
      });
    }
    else{
      col = -1
    }

    return col;
  }
  
  /**
   * Retourne un tableau contenant les colonnes par ligne
   * @param {number} col Nombre de colonne par ligne
   * @return {any[]}
   */
  groupColumn(col){
    let groups = [];
    let divs = this.$columns;
    if(col>0){
      for(let i = 0; i < divs.length; i+=col) {
        groups.push(divs.slice(i, i+col));
      }
    }
    else if(col == -1){
      groups.push(this.$columns);
    }
    return groups;
  }

  /**
   * Récupère toutes les heights des éléments
   * @param {any[]} $elemsArray Tableau contenant les objets jQuery
   */
  getHeights($elemsArray){
    let heights = []
    $elemsArray.forEach(element => {
      let $element = $(element).css("height", "");
      heights.push($element.innerHeight());
    });
    return heights
  }
  
  /**
   * Applique la hauteur max aux éléments
   * @param {any[]} $elemsArray Tableau contenant les objets jQuery
   */
  applyHeight($elemsArray){
    let max = Math.max.apply(null, this.getHeights($elemsArray));
    $elemsArray.forEach(element => {
      element.css("height", max);
    });
  }

  /**
   * Reset Toutes les hauteurs par défault
   */
  resetAllHeight(){
    this.elemsToEqualize.forEach(elClass => {
      this.$row.find(elClass).css("height","");
    });
  }

  /**
   * Throttle Function For Performance
   */
  throttle(func, limit) {
    this.lastFunc
    this.lastRan
    
    const context = this
    const args = arguments
    if (!this.lastRan) {
      func.apply(context, args)
      this.lastRan = Date.now()
    } else {
      clearTimeout(this.lastFunc)
      this.lastFunc = setTimeout(() => {
        if ((Date.now() - this.lastRan) >= limit) {
          func.apply(context, args)
          this.lastRan = Date.now()
        }
      }, limit - (Date.now() - this.lastRan))
    }
  
  }
};

